import React, { useState } from 'react';
import './../../../assets/css/mentor/mentordashboard/Mentorprofile.css';
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';

const MentorProfileSettings = () => {
  const [activeTab, setActiveTab] = useState('profile-info');
  const [formData, setFormData] = useState({
    // Profile Info
    fullName: 'Dr. Sarah Ahmed',
    role: 'Senior Software Architect & AI Specialist',
    bio: 'Passionate about mentoring the next generation of software engineers. 15+ years of experience in full-stack development, cloud architecture, and machine learning.',
    expertise: ['React', 'Node.js', 'Python', 'AWS', 'Machine Learning', 'System Design'],
    profileImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    
    // Professional Details
    yearsExperience: '15',
    currentCompany: 'Tech Innovators Inc.',
    position: 'Lead Solutions Architect',
    education: 'PhD in Computer Science',
    certifications: ['AWS Certified Solutions Architect', 'Google Cloud Professional', 'Certified Scrum Master'],
    skills: ['Leadership', 'Code Review', 'Architecture Design', 'Agile Methodologies'],
    
    // Availability
    availableDays: ['Monday', 'Wednesday', 'Friday'],
    timeSlots: ['9:00 AM - 12:00 PM', '2:00 PM - 5:00 PM'],
    sessionPrice: '5000',
    sessionDuration: '60',
    
    // Security
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    
    // Notifications
    emailNotifications: true,
    smsNotifications: false,
    sessionReminders: true,
    newStudentAlerts: true,
    weeklyReports: true
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleArrayAdd = (field, value) => {
    if (value.trim()) {
      setFormData(prev => ({
        ...prev,
        [field]: [...prev[field], value.trim()]
      }));
    }
  };

  const handleArrayRemove = (field, index) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index)
    }));
  };

  const handleDayToggle = (day) => {
    setFormData(prev => ({
      ...prev,
      availableDays: prev.availableDays.includes(day)
        ? prev.availableDays.filter(d => d !== day)
        : [...prev.availableDays, day]
    }));
  };

  const handleSave = () => {
    alert('Settings saved successfully!');
  };

  const tabs = [
    { id: 'profile-info', label: 'Profile Info', icon: '👤' },
    { id: 'professional', label: 'Professional Details', icon: '💼' },
    { id: 'availability', label: 'Availability & Sessions', icon: '📅' },
    { id: 'security', label: 'Security Settings', icon: '🔒' },
    { id: 'notifications', label: 'Notifications', icon: '🔔' }
  ];

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const renderContent = () => {
    switch (activeTab) {
      case 'profile-info':
        return (
          <div className="tmh-mentor-content-wrapper">
            <div className="tmh-mentor-section-header">
              <h2 className="tmh-mentor-section-title">Profile Information</h2>
              <p className="tmh-mentor-section-subtitle">Update your personal and professional profile information</p>
            </div>

            <div className="tmh-mentor-card">
              <div className="tmh-mentor-profile-image-section">
                <div className="tmh-mentor-image-preview">
                  <img src={formData.profileImage} alt="Profile" className="tmh-mentor-profile-img" />
                </div>
                <div className="tmh-mentor-image-actions">
                  <button className="tmh-mentor-btn-secondary">Change Photo</button>
                  <p className="tmh-mentor-helper-text">JPG or PNG. Max size 2MB</p>
                </div>
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Professional Role</label>
                <input
                  type="text"
                  name="role"
                  value={formData.role}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                  placeholder="e.g., Senior Software Engineer"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Bio</label>
                <textarea
                  name="bio"
                  value={formData.bio}
                  onChange={handleInputChange}
                  className="tmh-mentor-textarea"
                  rows="5"
                  placeholder="Tell students about yourself and your mentoring approach"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Areas of Expertise</label>
                <div className="tmh-mentor-tags-container">
                  {formData.expertise.map((skill, index) => (
                    <span key={index} className="tmh-mentor-tag">
                      {skill}
                      <button
                        onClick={() => handleArrayRemove('expertise', index)}
                        className="tmh-mentor-tag-remove"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                <div className="tmh-mentor-add-input-group">
                  <input
                    type="text"
                    className="tmh-mentor-input"
                    placeholder="Add expertise (e.g., React, Python)"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleArrayAdd('expertise', e.target.value);
                        e.target.value = '';
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="tmh-mentor-actions">
              <button className="tmh-mentor-btn-primary" onClick={handleSave}>Save Changes</button>
              <button className="tmh-mentor-btn-secondary">Cancel</button>
            </div>
          </div>
        );

      case 'professional':
        return (
          <div className="tmh-mentor-content-wrapper">
            <div className="tmh-mentor-section-header">
              <h2 className="tmh-mentor-section-title">Professional Details</h2>
              <p className="tmh-mentor-section-subtitle">Showcase your experience and qualifications</p>
            </div>

            <div className="tmh-mentor-card">
              <div className="tmh-mentor-form-row">
                <div className="tmh-mentor-form-group">
                  <label className="tmh-mentor-label">Years of Experience</label>
                  <input
                    type="number"
                    name="yearsExperience"
                    value={formData.yearsExperience}
                    onChange={handleInputChange}
                    className="tmh-mentor-input"
                  />
                </div>

                <div className="tmh-mentor-form-group">
                  <label className="tmh-mentor-label">Current Position</label>
                  <input
                    type="text"
                    name="position"
                    value={formData.position}
                    onChange={handleInputChange}
                    className="tmh-mentor-input"
                  />
                </div>
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Current Company</label>
                <input
                  type="text"
                  name="currentCompany"
                  value={formData.currentCompany}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Education</label>
                <input
                  type="text"
                  name="education"
                  value={formData.education}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Certifications</label>
                <div className="tmh-mentor-tags-container">
                  {formData.certifications.map((cert, index) => (
                    <span key={index} className="tmh-mentor-tag">
                      {cert}
                      <button
                        onClick={() => handleArrayRemove('certifications', index)}
                        className="tmh-mentor-tag-remove"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                <div className="tmh-mentor-add-input-group">
                  <input
                    type="text"
                    className="tmh-mentor-input"
                    placeholder="Add certification"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleArrayAdd('certifications', e.target.value);
                        e.target.value = '';
                      }
                    }}
                  />
                </div>
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Additional Skills</label>
                <div className="tmh-mentor-tags-container">
                  {formData.skills.map((skill, index) => (
                    <span key={index} className="tmh-mentor-tag">
                      {skill}
                      <button
                        onClick={() => handleArrayRemove('skills', index)}
                        className="tmh-mentor-tag-remove"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                <div className="tmh-mentor-add-input-group">
                  <input
                    type="text"
                    className="tmh-mentor-input"
                    placeholder="Add skill"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleArrayAdd('skills', e.target.value);
                        e.target.value = '';
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="tmh-mentor-actions">
              <button className="tmh-mentor-btn-primary" onClick={handleSave}>Save Changes</button>
              <button className="tmh-mentor-btn-secondary">Cancel</button>
            </div>
          </div>
        );

      case 'availability':
        return (
          <div className="tmh-mentor-content-wrapper">
            <div className="tmh-mentor-section-header">
              <h2 className="tmh-mentor-section-title">Availability & Session Settings</h2>
              <p className="tmh-mentor-section-subtitle">Set your availability and session preferences for students</p>
            </div>

            <div className="tmh-mentor-card">
              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Available Days</label>
                <div className="tmh-mentor-days-grid">
                  {days.map(day => (
                    <button
                      key={day}
                      className={`tmh-mentor-day-btn ${formData.availableDays.includes(day) ? 'tmh-mentor-day-active' : ''}`}
                      onClick={() => handleDayToggle(day)}
                    >
                      {day.slice(0, 3)}
                    </button>
                  ))}
                </div>
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Available Time Slots</label>
                <div className="tmh-mentor-tags-container">
                  {formData.timeSlots.map((slot, index) => (
                    <span key={index} className="tmh-mentor-tag">
                      {slot}
                      <button
                        onClick={() => handleArrayRemove('timeSlots', index)}
                        className="tmh-mentor-tag-remove"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                <p className="tmh-mentor-helper-text">Click on a time slot to remove it</p>
              </div>

              <div className="tmh-mentor-form-row">
                <div className="tmh-mentor-form-group">
                  <label className="tmh-mentor-label">Session Price (PKR)</label>
                  <input
                    type="number"
                    name="sessionPrice"
                    value={formData.sessionPrice}
                    onChange={handleInputChange}
                    className="tmh-mentor-input"
                  />
                  <p className="tmh-mentor-helper-text">Price per session</p>
                </div>

                <div className="tmh-mentor-form-group">
                  <label className="tmh-mentor-label">Session Duration (minutes)</label>
                  <select
                    name="sessionDuration"
                    value={formData.sessionDuration}
                    onChange={handleInputChange}
                    className="tmh-mentor-input"
                  >
                    <option value="30">30 minutes</option>
                    <option value="45">45 minutes</option>
                    <option value="60">60 minutes</option>
                    <option value="90">90 minutes</option>
                    <option value="120">120 minutes</option>
                  </select>
                </div>
              </div>

              <div className="tmh-mentor-info-box">
                <div className="tmh-mentor-info-icon">ℹ️</div>
                <div>
                  <p className="tmh-mentor-info-title">Session Guidelines</p>
                  <p className="tmh-mentor-info-text">Students will be able to book sessions during your available time slots. Make sure to keep your calendar updated.</p>
                </div>
              </div>
            </div>

            <div className="tmh-mentor-actions">
              <button className="tmh-mentor-btn-primary" onClick={handleSave}>Save Changes</button>
              <button className="tmh-mentor-btn-secondary">Cancel</button>
            </div>
          </div>
        );

      case 'security':
        return (
          <div className="tmh-mentor-content-wrapper">
            <div className="tmh-mentor-section-header">
              <h2 className="tmh-mentor-section-title">Security Settings</h2>
              <p className="tmh-mentor-section-subtitle">Manage your password and security preferences</p>
            </div>

            <div className="tmh-mentor-card">
              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Current Password</label>
                <input
                  type="password"
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                  placeholder="Enter current password"
                />
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                  placeholder="Enter new password"
                />
                <p className="tmh-mentor-helper-text">Minimum 8 characters with letters and numbers</p>
              </div>

              <div className="tmh-mentor-form-group">
                <label className="tmh-mentor-label">Confirm New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  className="tmh-mentor-input"
                  placeholder="Confirm new password"
                />
              </div>

              <div className="tmh-mentor-security-info">
                <div className="tmh-mentor-security-item">
                  <span className="tmh-mentor-security-label">Last Password Change:</span>
                  <span className="tmh-mentor-security-value">30 days ago</span>
                </div>
                <div className="tmh-mentor-security-item">
                  <span className="tmh-mentor-security-label">Two-Factor Authentication:</span>
                  <span className="tmh-mentor-security-value tmh-mentor-badge-inactive">Not Enabled</span>
                </div>
              </div>
            </div>

            <div className="tmh-mentor-actions">
              <button className="tmh-mentor-btn-primary" onClick={handleSave}>Update Password</button>
              <button className="tmh-mentor-btn-secondary">Cancel</button>
            </div>
          </div>
        );

      case 'notifications':
        return (
          <div className="tmh-mentor-content-wrapper">
            <div className="tmh-mentor-section-header">
              <h2 className="tmh-mentor-section-title">Notification Preferences</h2>
              <p className="tmh-mentor-section-subtitle">Choose how you want to receive updates from students</p>
            </div>

            <div className="tmh-mentor-card">
              <div className="tmh-mentor-notification-item">
                <div className="tmh-mentor-notification-info">
                  <h4 className="tmh-mentor-notification-title">Email Notifications</h4>
                  <p className="tmh-mentor-notification-desc">Receive updates and alerts via email</p>
                </div>
                <label className="tmh-mentor-switch">
                  <input
                    type="checkbox"
                    name="emailNotifications"
                    checked={formData.emailNotifications}
                    onChange={handleInputChange}
                  />
                  <span className="tmh-mentor-switch-slider"></span>
                </label>
              </div>

              <div className="tmh-mentor-notification-item">
                <div className="tmh-mentor-notification-info">
                  <h4 className="tmh-mentor-notification-title">SMS Notifications</h4>
                  <p className="tmh-mentor-notification-desc">Get important updates via text message</p>
                </div>
                <label className="tmh-mentor-switch">
                  <input
                    type="checkbox"
                    name="smsNotifications"
                    checked={formData.smsNotifications}
                    onChange={handleInputChange}
                  />
                  <span className="tmh-mentor-switch-slider"></span>
                </label>
              </div>

              <div className="tmh-mentor-notification-item">
                <div className="tmh-mentor-notification-info">
                  <h4 className="tmh-mentor-notification-title">Session Reminders</h4>
                  <p className="tmh-mentor-notification-desc">Reminders 24 hours before scheduled sessions</p>
                </div>
                <label className="tmh-mentor-switch">
                  <input
                    type="checkbox"
                    name="sessionReminders"
                    checked={formData.sessionReminders}
                    onChange={handleInputChange}
                  />
                  <span className="tmh-mentor-switch-slider"></span>
                </label>
              </div>

              <div className="tmh-mentor-notification-item">
                <div className="tmh-mentor-notification-info">
                  <h4 className="tmh-mentor-notification-title">New Student Alerts</h4>
                  <p className="tmh-mentor-notification-desc">Get notified when new students book sessions</p>
                </div>
                <label className="tmh-mentor-switch">
                  <input
                    type="checkbox"
                    name="newStudentAlerts"
                    checked={formData.newStudentAlerts}
                    onChange={handleInputChange}
                  />
                  <span className="tmh-mentor-switch-slider"></span>
                </label>
              </div>

              <div className="tmh-mentor-notification-item">
                <div className="tmh-mentor-notification-info">
                  <h4 className="tmh-mentor-notification-title">Weekly Reports</h4>
                  <p className="tmh-mentor-notification-desc">Summary of your mentoring activity each week</p>
                </div>
                <label className="tmh-mentor-switch">
                  <input
                    type="checkbox"
                    name="weeklyReports"
                    checked={formData.weeklyReports}
                    onChange={handleInputChange}
                  />
                  <span className="tmh-mentor-switch-slider"></span>
                </label>
              </div>
            </div>

            <div className="tmh-mentor-actions">
              <button className="tmh-mentor-btn-primary" onClick={handleSave}>Save Preferences</button>
              <button className="tmh-mentor-btn-secondary">Cancel</button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <MyMasterLayout>
    <div className="tmh-mentor-settings-container">
      <div className="tmh-mentor-sidebar">
        <div className="tmh-mentor-sidebar-header">
          <h3 className="tmh-mentor-sidebar-title">Settings</h3>
        </div>
        <nav className="tmh-mentor-nav">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tmh-mentor-nav-item ${activeTab === tab.id ? 'tmh-mentor-nav-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tmh-mentor-nav-icon">{tab.icon}</span>
              <span className="tmh-mentor-nav-label">{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="tmh-mentor-main-content">
        {renderContent()}
      </div>
    </div>
    </MyMasterLayout>
  );
};

export default MentorProfileSettings;